import { openReviewer, openAcademic, openAuthor } from '@/api/open'

export default {
  data() {
    return {
      detail: {},
      decisionType: '',
      code: '',
      authorId: '',
      type: ''
    }
  },
  mounted() {
    this.code = this.$route.query.code
    this.decisionType = this.$route.query.decisionType
    this.authorId = this.$route.query.id
    this.getQuery(this.code)
  },
  methods: {
    async getQuery() {
      let data = {}
      if (this.decisionType) {
        data = await openAcademic.academicCode(this.code)
      } else if (this.authorId) {
        // console.log(this.authorId, 'll')
        let datas = {
          sign: this.$route.query.sign
        }
        data = await openAuthor.authorMascript(this.authorId, datas)
      } else {
        data = await openReviewer.reviewsCode(this.code)
        this.type = 'review'
      }
      this.detail = data
    }
  }
}
